import React, { useState } from 'react';
import { AiOutlineClose, AiOutlineMenu } from 'react-icons/ai';
import { Link } from 'react-router-dom'; 
import logo from '../assets/logo.svg';

export default function Header() {
  const [nav, setNav] = useState(false);

  const handleNav = () => {
    setNav(!nav);
  };

  return (
    <div>
      {/* Header Section */}
      <header className='bg-[#000C66] p-4'>
        <div className='max-w-[1240px] flex items-center justify-between mx-auto'>
          <div className='flex items-center'>
            <Link to="/home">
              <img src={logo} alt="TrustForge Logo" className="h-16 w-auto" />
            </Link>
            <nav className="hidden md:flex space-x-4 ml-4">
              <Link to="/home" className="hover:text-blue-300 font-bold text-amber-50">HOME</Link>
              <Link to="/aboutus" className="hover:text-blue-300 font-bold text-amber-50">ABOUT</Link>
              <Link to="/blog" className="hover:text-blue-300 font-bold text-amber-50">BLOG</Link>
              <Link to="/dashboard" className="hover:text-blue-300 font-bold text-amber-50">DASHBOARD</Link>
            </nav>
          </div>
          <div className="hidden md:flex space-x-2">
            <Link to="/login" className="bg-customLogin text-white px-4 py-2 rounded font-bold">LOGIN</Link>
            <Link to="/signup" className="bg-customColor text-white px-4 py-2 rounded font-bold">SIGN UP</Link>
          </div>
          <div className="md:hidden" onClick={handleNav}>
            {!nav ? <AiOutlineMenu size={25} className="text-white" /> : <AiOutlineClose size={25} className="text-white" />}
          </div>
        </div>
        {/* Mobile Menu */}
        <div className={nav ? 'md:hidden fixed left-0 top-0 w-full h-full bg-[#000C66] p-4 flex flex-col justify-center items-center' : 'hidden'}>
          <div className="flex justify-between w-full px-4">
            <AiOutlineClose size={25} className="text-white" onClick={handleNav} />
          </div>
          <Link to="/home" className="py-6 text-4xl font-bold text-amber-50" onClick={handleNav}>HOME</Link>
          <Link to="/aboutus" className="py-6 text-4xl font-bold text-amber-50" onClick={handleNav}>ABOUT</Link>
          <Link to="/blog" className="py-6 text-4xl font-bold text-amber-50" onClick={handleNav}>BLOG</Link>
          <Link to="/dashboard" className="py-6 text-4xl font-bold text-amber-50" onClick={handleNav}>DASHBOARD</Link>
          <div className="flex space-x-2 mt-6">
            <Link to="/login" className="bg-customLogin text-white px-4 py-2 rounded font-bold">LOGIN</Link>
            <Link to="/signup" className="bg-customColor text-white px-4 py-2 rounded font-bold">SIGN UP</Link>
          </div>
        </div>
      </header>
    </div>
  );
}
